import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSpecsFormService extends Service {
  constructor({repository}) {
    super({repository})
    this._repository = repository
  }

  /**
   * @return {Promise<SpecsFormValueObject, Error>} returns the specs for a form builder
   */
  @inlineError
  async execute({searchUrlVO}) {
    const [specsFormError, specsFormResponse] = await this._repository.getSpecsForm({searchUrlVO})

    if (specsFormError) {
      return Promise.reject(specsFormError)
    }

    return specsFormResponse
  }
}
